import React from "react";
import { styled } from "@mui/material";
import MuiTooltip, { tooltipClasses } from "@mui/material/Tooltip";

export const Tooltip = styled(({ className, ...props }: any) => {
    return <MuiTooltip {...props} classes={{ popper: className }} />;
})(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}));
